<app-nav-bar></app-nav-bar>
<div id="innerHeader" class="container-fluid" style="padding-bottom: 5rem;">
  <div class="row"></div>
</div>
<router-outlet></router-outlet>
<app-footer></app-footer>
